// extracted by mini-css-extract-plugin
export default {"tooltip":"Tooltip_tooltip__MZIeA","tooltip__bubble":"Tooltip_tooltip__bubble__C+IpD"};